export const SET_PLAYERS_NAMES = 'SET_PLAYERS_NAMES';
export const SET_DICES = 'SET_DICES';
export const SET_DEBUG = 'SET_DEBUG';
export const RESET_GAME = 'RESET_GAME';
export const SHOW_RESET_GAME = 'SHOW_RESET_GAME';
export const CLOSE_FORMS = 'CLOSE_FORMS';
